// Diagnostics for the playlist layer, built so a URL or a credential can't get into a log by accident: only a
// fixed set of keys is accepted, and a string value with anything URL-ish in it is replaced instead of printed.
// Callers pass codes, counts and short tags, never playlist data.

const ALLOWED_KEYS = ["adapter", "op", "code", "reason", "fp", "count", "from", "to"];
const MAX_VALUE_LENGTH = 64;
// anything that can only appear in a URL, a query string or a credential pair
const UNSAFE_VALUE = /[\/?&=@#%\\\s]|:\/\//;

let platformLabel = "unknown";

const sanitizeValue = (value) => {
    if (value.length > MAX_VALUE_LENGTH || UNSAFE_VALUE.test(value)) return "[redacted]";
    return value;
};

export const setPlaylistLogPlatform = (label) => {
    platformLabel = sanitizeValue(label || "") || "unknown";
};

// short prefix of a fingerprint: enough to correlate two log lines, not enough to recover anything
export const fingerprintTag = (fingerprint) => (fingerprint || "").slice(0, 8);

export const logPlaylist = (level, event, fields = {}) => {

    try {

        const safe = { platform: platformLabel };

        for (let i = 0; i < ALLOWED_KEYS.length; i++) {
            const key = ALLOWED_KEYS[i];
            const value = fields[key];
            if (typeof value === "number" && isFinite(value)) safe[key] = value;
            else if (typeof value === "string" && value) safe[key] = sanitizeValue(value);
        }

        console.warn(`[playlists:${level}] ${sanitizeValue(event)} ${JSON.stringify(safe)}`);

    } catch (e) {
        // logging must never be the thing that breaks a save
    }

};
